import { styled } from '@mui/material/styles'
const PREFIX = 'ProgressModal'

export const classes = {
  paper: `${PREFIX}-paper`,
  modal: `${PREFIX}-modal`,
  message: `${PREFIX}-message`,
}

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.paper}`]: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1),
    width: theme.spacing(30),
  },
  [`&.${classes.modal}`]: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  [`& .${classes.message}`]: {
    textAlign: 'center',
    display: 'block',
    lineHeight: 1.3,
    fontWeight: 600,
    margin: '14px 0 8px',
  },
}))

export default Root
